import { render, staticRenderFns } from "./mMain.vue?vue&type=template&id=0c8e3c9e&scoped=true"
import script from "./mMain.vue?vue&type=script&lang=js"
export * from "./mMain.vue?vue&type=script&lang=js"
import style0 from "./mMain.vue?vue&type=style&index=0&id=0c8e3c9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8e3c9e",
  null
  
)

export default component.exports